'use strict';

var styled = require('styled-components');
var styles = require('../Anchor/styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const Ul = styled__default.default.ul `
  list-style: none;
  margin: 0;
  padding: 0;
  ${styles.Styled.Anchor} {
    color: inherit;
    font: inherit;
    text-decoration: none;
  }
`;
const Li = styled__default.default.li `
  display: block;
  text-align: left;
  margin: 0;
  padding: 0;
  padding-left: ${({ theme }) => theme.designTokens.treeItemPaddingLeft};
  color: ${({ errored, theme }) => errored ? theme.designTokens.treeErroredTextColor : theme.designTokens.treeTextColor};
`;
const Heading = styled__default.default.div `
  color: ${({ errored, theme }) => errored ? theme.designTokens.treeErroredTextColor : theme.designTokens.treeTextColor};
`;
const Styled = {
    Ul,
    Li,
    Heading,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
